import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import JsBarcode from 'jsbarcode'
import { useParams } from 'react-router-dom';


const BarcodeCreate = () => {

    const {barcode} = useParams();

    console.log("barcode", barcode);

    if(barcode === null || barcode === ""){
        alert("바코드를 입력해 주세요");
    }

    let imageUrl = "";
    const barcodeNumber = barcode;
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, barcodeNumber, { height: 100, displayValue: false });
    imageUrl = canvas.toDataURL('image/png');



    return (
      <>
            <div><img src={imageUrl} /></div>
      </>
    );

}

export default BarcodeCreate;